/* drawer */
const app = document.querySelector<HTMLElement>('#app');
/*--------------------------------------------------------------------------------*/
type reqParams = {
    title: string;
    body: string;
    name?: string;
    size?: string; // mobile, full
};
export const create = (params: reqParams): HTMLElement => {
    const name = params.name ? params.name : 'drawer';
    const size = params.size ? params.size : 'mobile';
    // create
    const drawer = document.createElement('div');
    drawer.className = `slim-drawer ${size}`;
    drawer.innerHTML = /*html*/ `
        <div class="drawer-header">
            <button id="btn-exit" type="button"
                class="circle sm light"></button>
            <div class="title">${params.title}</div>
        </div>
        <div class="drawer-body">${params.body}</div>
        <div class="loader">
            <div class="spinner s32"></div>
        </div>
    `;
    document.body.appendChild(drawer);
    // set size
    switch (size) {
        case 'mobile': openMobile(drawer); break;
        case 'full':
            drawer.style.animation = 'slide-in-left 0.4s forwards';
            break;
        default: return drawer;
    }
    // hash change
    window.location.hash = name;
    const hashChange = () => {
        const hash = (window.location.hash).replaceAll('#', '');
        if (hash != name && hash != 'modal') done();
    };
    const done = () => {
        destroy(drawer);
        if (window.location.hash == `#${name}`) history.back();
        window.removeEventListener('hashchange', hashChange);
    };
    window.addEventListener('hashchange', hashChange);
    // button
    const btnExit = drawer.querySelector<HTMLButtonElement>('#btn-exit');
    const btnCancel = drawer.querySelector<HTMLButtonElement>('#btn-cancel');
    if (btnExit) {
        btnExit.focus();
        btnExit.onclick = done;
    }
    if (btnCancel) btnCancel.onclick = done;
    return drawer;
};
/*--------------------------------------------------------------------------------*/
const openMobile = (drawer: HTMLElement) => {
    if (!app) return;
    const offset = app.getBoundingClientRect();
    const appRight = offset.right;
    const appWidth = app.offsetWidth;
    // default position
    drawer.style.left = `${appRight}px`;
    // animation
    const css = document.createElement('style');
    drawer.appendChild(css);
    css.sheet?.insertRule(`
        @keyframes drawer-in {
            from {transform: translateX(0);}
            to   {transform: translateX(-${appWidth}px);}
        }
    `);
    css.sheet?.insertRule(`
        @keyframes drawer-out {
            from {transform: translateX(-${appWidth}px);}
            to   {transform: translateX(0);}
        }
    `);
    // open drawer
    const content = app.querySelector<HTMLElement>('#app-content');
    if (content) content.style.animation = 'drawer-push-app 0.4s forwards';
    drawer.style.animation = 'drawer-in 0.4s forwards';
    // scroll shadow
    const header = drawer.querySelector<HTMLElement>('.drawer-header');
    const body = drawer.querySelector<HTMLElement>('.drawer-body');
    if (header && body) body.onscroll = () => {
        if (body.scrollTop > 10) {
            header.style.boxShadow = `
                rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
                rgba(60, 64, 67, 0.15) 0px 1px 3px 1px
            `;
        } else {
            header.style.boxShadow = '';
        }
    };
};
/*--------------------------------------------------------------------------------*/
export const close = (drawer: HTMLElement) => new Promise<void>((resolve) => {
    drawer.querySelector<HTMLButtonElement>('#btn-exit')!.click();
    drawer.addEventListener('animationend', () => resolve());
});
const destroy = (drawer: HTMLElement) => {
    if (!app) return;
    if (drawer.classList.contains('mobile')) {
        // mobile
        const content = app.querySelector<HTMLElement>('#app-content');
        if (content) content.style.animation = 'drawer-pull-app 0.4s forwards';
        drawer.style.animation = 'drawer-out 0.4s forwards';
        drawer.addEventListener('animationend', () => {
            if (content) content.style.animation = 'unset';
            drawer.remove();
        });
    } else {
        // full-page
        drawer.style.animation = 'slide-out-left 0.4s forwards';
        drawer.addEventListener('animationend', () => {
            drawer.remove();
        });
    }
    // remove modal
    const modal = document.querySelectorAll<HTMLElement>('.slim-modal');
    modal.forEach(el => el.remove());
    // remove dialog
    const dialog = document.querySelectorAll<HTMLElement>('.slim-dialog');
    dialog.forEach(el => el.remove());
};
/*--------------------------------------------------------------------------------*/
export const loading = (drawer: HTMLElement) => {
    const body = drawer.querySelector<HTMLElement>('.drawer-body');
    const loader = drawer.querySelector<HTMLElement>('.loader');
    if (body) body.style.display = 'none';
    if (loader) loader.style.display = 'flex';
};
/*--------------------------------------------------------------------------------*/
export const ready = (drawer: HTMLElement) => {
    const body = drawer.querySelector<HTMLElement>('.drawer-body');
    const loader = drawer.querySelector<HTMLElement>('.loader');
    if (body) body.style.display = 'block';
    if (loader) loader.style.display = 'none';
};
/*--------------------------------------------------------------------------------*/
